import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({ providedIn: 'root' })
export class DeferredToastService {
  private STORAGE_KEY = 'pendingToast';

  constructor(private toastr: ToastrService) {}

  queueSuccess(message: string | undefined) {
    this.queueToast('success', message);
  }

  queueWarning(message: string | undefined) {
    this.queueToast('warning', message);
  }

  queueError(message: string | undefined) {
    this.queueToast('error', message);
  }

  showQueuedMessage() {
    const item = sessionStorage.getItem(this.STORAGE_KEY);
    if (item) {
      const toast = JSON.parse(item);

      if (toast.type === 'success')
        this.toastr.success(toast.message);
      else if (toast.type === 'warning')
        this.toastr.warning(toast.message);
      else if (toast.type === 'error')
        this.toastr.error(toast.message);

      sessionStorage.removeItem(this.STORAGE_KEY);
    }
  }

  private queueToast(type: string, message: string | undefined) {
    if (!message) return;
    sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify({ type, message }));
  }
}
